let infosBanner = {
    delimiters: ['%%', '%%'],
    components: {
        infosBannerItem
    },
    data() {
        return {
            infosBannersLoaded: false,
            infosBanners: [],
        };
    },
    mounted: function() {
        fetch(apidae.site_url + 'wp-json/wp/v2/infos')
            .then((response) => response.json())
            .then((data) => {
                if (data.length > 0) {
                    this.infosBannersLoaded = true;
                    this.infosBanners = data;
                    const swiperLoop = (this.infosBanners.length > 1) ? true : false;
                    imagesLoaded(this, function() {
                        jQuery('.owl-carousel').owlCarousel({
                            loop: true,
                            autoplay: true,
                            autoplayTimeout: 5000,
                            autoplayHoverPause: true,
                            margin: 0,
                            nav: true,
                            dots: false,
                            navText: ['<i class="fal fa-long-arrow-left"></i>', '<i class="fal fa-long-arrow-right"></i>'],
                            responsive: {
                                0: {
                                    items: 1
                                },
                                600: {
                                    items: 1
                                },
                                800: {
                                    items: 1
                                },
                                1000: {
                                    items: 1
                                }
                            }
                        });
                    })
                }
            });
    },
    template: `
        <div class="infos__banner relative">
            <div class="px-3 py-2 text-base text-white owl-carousel">
                <div class="" v-for="infosBanner in infosBanners" :key="infosBanner.id">
                    <infos-banner-item :infos-banner="infosBanner"></infos-banner-item>
                </div>
            </div>
        </div>`
};

if (document.querySelector('#infosBanner')) {
    // console.log(nb);
    new Vue({
        delimiters: ['%%', '%%'],
        el: document.querySelector('#infosBanner'),
        components: {
            infosBanner
        },
        store
    });
}